<template>
  <div v-if="task">
    <task-body :task="task" :try-join="tryJoin" :try-leave="tryLeave" />
    <box>
      <h3 class="mb-5">{{ $tc('reward', 2) }}</h3>
      <rewards-list :type="task.title" :rewards="task.subTasks" />
      <!-- <b-row class="mb-1">
        <b-col md="12" lg="6" xl="4">
          <reward
            class="mb-4"
            title="Join"
            icon="follow"
            :prices="[{ price: 0.25 }]"
            :daily-limit="{ min: 1, max: 20 }"
            :weekly-limit="{ min: 1, max: 20 }"
          />
        </b-col>
        <b-col md="12" lg="6" xl="4">
          <reward
            class="mb-4"
            title="Upvote"
            icon="like"
            :prices="[{ price: 0.25 }]"
            :daily-limit="{ min: 1, max: 20 }"
            :weekly-limit="{ min: 1, max: 20 }"
          />
        </b-col>
        <b-col md="12" lg="6" xl="4">
          <reward
            class="mb-4"
            title="Resteem"
            icon="repost"
            :prices="[{ price: 0.25 }]"
            :daily-limit="{ min: 1, max: 20 }"
            :weekly-limit="{ min: 1, max: 20 }"
          />
        </b-col>
        <b-col md="12" lg="6" xl="4">
          <reward
            class="mb-4"
            title="Post"
            icon="post"
            metric-title="Folowers"
            :prices="[{ min: 0, max: 1000, price: 0.25 }]"
          />
        </b-col>
        <b-col md="12" lg="6" xl="4">
          <reward
            class="mb-4"
            title="Comment"
            icon="comment-o"
            metric-title="Folowers"
            :prices="[
              { min: 0, max: 1000, price: 0.25 },
              { min: 1001, max: 5000, price: 0.5 }
            ]"
          />
        </b-col>
      </b-row> -->
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';
import RewardsList from '@/views/Campaign/BountyCampaign/components/RewardsList.vue';

export default {
  mixins: [taskMixin],

  components: {
    RewardsList
  }
};
</script>
